/*
  Expone como global el Flickity que ya viene en vendor.js.

  vendor.js bundlea Flickity v3.0.0, pero es un IIFE que solo publica
  `themeVendor`: no toca window. theme.js no lo necesita porque usa
  themeVendor.Flickity directo, pero el código custom del theme llama al global
  `new Flickity(...)` en cinco lugares:

    - layout/theme.liquid          (init inline de .js-flickity)
    - assets/custom.js             (flickity-slider-v2, sliders de section-icons)
    - assets/custom-video-carousel.js
    - assets/custom-calculadora-raciones.js
    - sections/section-collection.liquid

  Ese global lo daban dos copias v2 traídas de unpkg y de jsdelivr, o sea dos
  CDN de terceros en el camino crítico de esos cinco sliders: si alguno se caía
  o tardaba, se rompían. Este puente usa el que ya está en el bundle y nos saca
  la dependencia externa de encima.

  Se carga como asset deferred inmediatamente después de vendor.js. Los scripts
  deferred corren en orden de documento y vendor.js está antes de
  content_for_layout, así que el global queda definido antes de theme.js, de
  cualquier script de sección y de custom.js.

  El `||` es a propósito: si alguna página todavía trae una copia externa, no la
  pisamos.
*/
if (window.themeVendor) {
  window.Flickity = window.Flickity || window.themeVendor.Flickity;
  window.FlickityFade = window.FlickityFade || window.themeVendor.FlickityFade;
  window.FlickitySync = window.FlickitySync || window.themeVendor.FlickitySync;
}
